import { Link } from 'react-router-dom';
import NewsListItem from '@/components/feature/NewsListItem';
import { newsList } from '@/mocks/newsData';
import type { NewsItem } from '@/types';

export default function NewsPreview() {
  const latest = (newsList as NewsItem[]).slice(0, 3);

  return (
    <section className="bg-background-100">
      <div className="mx-auto max-w-portal px-4 py-12 md:px-6 md:py-14">
        <div className="flex items-end justify-between gap-4">
          <div>
            <span className="text-xs font-semibold uppercase tracking-[0.25em] text-primary-700">Insights</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">投资资讯精选</h2>
            <p className="mt-2 text-sm text-foreground-600">权威市场分析与投资策略解读，每日更新</p>
          </div>
          <Link
            to="/category/investment-news"
            className="hidden shrink-0 items-center gap-1 text-sm font-medium text-primary-700 transition-colors hover:text-primary-600 sm:flex"
          >
            全部资讯
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="mt-8 grid gap-4">
          {latest.map((item) => (
            <NewsListItem key={item.id} item={item} />
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/investment-news"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-700"
          >
            查看全部资讯
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}